import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SistemaService} from '@servicios/Sistema.Service';
import {TranslateService} from '@ngx-translate/core';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';

@Component(
    {
        selector: 'fileCustom',
        templateUrl: './File.template.html',
        styleUrls: ['./File.scss'],
    })

export class FileComponent {
    @ViewChild('archivoInput') archivoInput: any;

    @Input() mimeTypeAceptado: string = "";
    @Input() seleccionMultiple: string = "";
    @Input() titulo: string = "";
    @Input() fileSave: boolean = false;

    @Input() verError: boolean = true;
    @Input() errorActivo: boolean = false;
    @Input() disabled: boolean = false;

    @Output() archivoSeleccionado: EventEmitter<any> = new EventEmitter();

    public archivo: any;
    public archivoNombre: string = "";
    public mimeTypeArchivo: any;

    public inputFileTouched: boolean = false;

    public id: number = 0;

    constructor(public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService) {
        this.sistemaService.numeroControl++;
        this.id = this.sistemaService.numeroControl;
    }

    ngOnInit() {
        this.archivoNombre = this.fileSave ? "File_Save" : this.archivoNombre;
    }

    SetArchivo(event: any) {
        var _URL = window.URL;
        var files = event.target.files;
        var reader = new FileReader();

        if (event.target.files && event.target.files[0]) {
            var error = this.ValidarTipoArchivo(event.target.files[0].type.toLowerCase());

            if (error) {
                reader.readAsDataURL(event.target.files[0]);
                this.archivoInput.nativeElement.value = "";
                this.mensajeService.Alerta(AlertaEnum.Warning, error);
                return;
            }
            else {
                this.archivoNombre = event.target.files[0].name;
                this.mimeTypeArchivo = event.target.files[0].type;
            }

            reader.onload = ((archivo: any) => {
                if (!error) {
                    let UrlFile = archivo.target.result;
                    let archivoBase64 = UrlFile.split('base64,')[1];

                    this.archivo = archivoBase64;

                    var valorArchivo =
                    {
                        Nombre: this.archivoNombre,
                        Archivo: this.archivo,
                        MimeType: this.mimeTypeArchivo
                    };

                    this.archivoSeleccionado.emit(valorArchivo);
                }
            });
        }

        if (event.target.files.length > 0) {
            reader.readAsDataURL(event.target.files[0]);
            this.archivoInput.nativeElement.value = "";
        }
    }

    ValidarTipoArchivo(tipoSeleccionado: string) {
        if (!this.mimeTypeAceptado) {
            return "";
        }

        var tipos = this.mimeTypeAceptado.trim().split(",");
        tipos = tipos.filter(p => {return p});

        for (var k = 0; k < tipos.length; k++) {
            let tipo = tipos[k].trim().toLowerCase();
            if (tipo.split("/*").length > 1) {
                if (tipo.split("/*")[0] == tipoSeleccionado.split("/")[0]) {
                    return "";
                }
            } else {
                if (tipo == tipoSeleccionado) {
                    return "";
                }
            }
        }

        return this.translate.instant("ErrorTipoArchivo");
    }

    LimpiarArchivo() {
        this.archivoNombre = "";
        this.archivoInput.nativeElement.value = "";
        this.archivoSeleccionado.emit(null);
    }
}
